<template>
    <div class="container franvaro">

        <div class="fk-content-wide" style="border-radius:6px;font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;font-weight:600;user-select: none;">

            <div class="info_area">

                <div style="font-size:42px;margin-bottom:30px;">

                    <div id="laddtext">Vänta lite...</div>

                    <div class="rubrik">Frånvaro i Falköpings kommun</div>

                    <div class="underrubrik">{{valda_inrors_string}}</div>

                    <div style="display:flex;flex-direction:row;justify-content:center;margin-top:20px;">
                        <div id="chart_1" style="background:white;width:1000px;height:600px;">&nbsp;</div>
                    </div>

                    <div id="explaining_text" class="explaining_text"></div>

                </div>

                <div class="side_menu">

                    <div class="side_menu_flik" @click="side_menu_open_close()">
                        <div class="side_menu_flik_text">Inställningar</div>
                    </div>

                    <div class="scrollable_content">

                        <div>
                            <label for="multiselect_inrors">Frånvaroorsaker</label>
                            <div id="multiselect_inrors" class="multiselect" style="z-index:100 !important;">
                                <multiselect v-model="valda_inrors"
                                             :options="options_inrors"
                                             :multiple="true"
                                             :searchable="false"
                                             :allow-empty="false"
                                             :close-on-select="false"
                                             :show-labels="false"
                                             placeholder="">
                                </multiselect>
                            </div>
                        </div>

                        <div>
                            <label for="multiselect_diagramtyp">Diagramtyper</label>
                            <div id="multiselect_diagramtyp" class="multiselect" style="z-index:100 !important;">
                                <multiselect v-model="vald_diagramtyp"
                                             :options="options_diagramtyper"
                                             :multiple="false"
                                             :searchable="false"
                                             :allow-empty="false"
                                             :close-on-select="true"
                                             :show-labels="false"
                                             placeholder="">
                                </multiselect>
                            </div>
                        </div>

                        <div style="display:flex;flex-direction:row;justify-content:space-between;">
                            <div>
                                <label for="fromdatum">Fr o m</label>
                                <input type="date" id="fromdatum" class="input_date" v-model="from_date" @blur="check_dates" />
                            </div>
                            <div class="my_spacer"></div>
                            <div>
                                <label for="tomdatum">T o m</label>
                                <input type="date" id="tomdatum" class="input_date" v-model="to_date" @blur="check_dates" />
                            </div>
                        </div>

                        <label for="interval">Intervall (dagar)</label>
                        <input type="number" id="interval" class="input_number" min="1" max="31" v-model="interval" />



                        <div class="btn-container">

                            <input type="radio" id="procent" value="true" v-model="show_percent" hidden />
                            <label class="btn-label" for="procent">Procent</label>

                            <input type="radio" id="antal" value="false" v-model="show_percent" hidden />
                            <label class="btn-label" for="antal">Antal</label>

                        </div>

                        <div class="btn-container">

                            <input type="radio" id="pagaende" value="true" v-model="show_ongoing" hidden />
                            <label class="btn-label" for="pagaende">Pågående</label>

                            <input type="radio" id="startar" value="false" v-model="show_ongoing" hidden />
                            <label class="btn-label" for="startar">Påbörjad</label>

                        </div>


                        <button id="button_fetch" class="button_fetch" @mousedown="Get_all_pagaende_franvaro()">Uppdatera diagram</button>


                        <div>
                            <label for="multiselect_diagramtyp">Snabbval</label>
                            <div id="multiselect_diagramtyp" class="multiselect" style="z-index:100 !important;">
                                <multiselect v-model="valt_snabbval"
                                             :options="options_snabbval"
                                             track-by="name"
                                             label="name"
                                             :multiple="false"
                                             :searchable="false"
                                             :allow-empty="true"
                                             :close-on-select="true"
                                             :show-labels="false"
                                             placeholder="Välj">
                                </multiselect>
                            </div>
                        </div>

                    </div>

                </div>

            </div>



        </div>
    </div>
</template>


<script>
    // Importera bibliotek vi använder
    import _ from "lodash";
    import Alert from './Alert.vue';
    import global_resources from './global_resources.js';
    import Vue from 'vue';
    import vSelect from 'vue-select';
    Vue.component('v-select', vSelect);
    import 'vue-select/dist/vue-select.css';
    import * as echarts from 'echarts';
    import Multiselect from 'vue-multiselect';

    // Registrera globalt - har inte kollat om det verkligen behövs här...
    Vue.component('multiselect', Multiselect)

    // Bra sak att ha med sig när man behöver ha inledande nollor som utfyllnad
    const zeroPad = (num, places) => String(num).padStart(places, '0');

    var logg = false;

    export default {
        // definiera variabler (allt som ligger inom data() här under)
        data() {
            return {
                show_percent: "true",
                show_ongoing: "true",
                laddtext: "Vänta lite - hämtar data...",
                echart1: null,
                from_date: "2022-01-01",
                to_date: "2022-06-30",
                interval: 7,
                vald_diagramtyp: ["Linjediagram"],
                valt_snabbval: [],
                options_snabbval: [
                    {
                        name: "Pågående semester, alla förvaltningar sedan 2019-05-01",
                        valda_inrors: ["Semester"],
                        vald_diagramtyp: ["Stapeldiagram"],
                        valda_forvaltningar: {
                            "Alla förvaltningar": true,
                            "Barn- och Utbildningsförvaltningen": false,
                            "Kommunledningsförvaltningen": false,
                            "Kompetens- och Arbetslivsförvaltningen": false,
                            "Kultur- och Fritidsförvaltningen": false,
                            "Samhällsbyggnadsförvaltningen": false,
                            "Samhällsskyddsförvaltningen": false,
                            "Socialförvaltningen": false,
                        },
                        from_date: "2019-05-01",
                        to_date: new Date().toLocaleDateString("sv"),
                        interval: 1,
                        show_percent: "true",
                        show_ongoing: "true",

                    },
                    {
                        name: "Påbörjad semester, alla förvaltningar, maj -22",
                        valda_inrors: ["Semester"],
                        vald_diagramtyp: ["Linjediagram"],
                        valda_forvaltningar: {
                            "Alla förvaltningar": false,
                            "Barn- och Utbildningsförvaltningen": true,
                            "Kommunledningsförvaltningen": true,
                            "Kompetens- och Arbetslivsförvaltningen": true,
                            "Kultur- och Fritidsförvaltningen": true,
                            "Samhällsbyggnadsförvaltningen": true,
                            "Samhällsskyddsförvaltningen": true,
                            "Socialförvaltningen": true,
                        },
                        from_date: "2022-05-01",
                        to_date: "2022-05-31",
                        interval: 1,
                        show_percent: "false",
                        show_ongoing: "false",

                    },
                    {
                        name: "Pågående sjukfrånvaro, SMS jmf. alla förv. senaste 3 mån",
                        valda_inrors: ["Sjuk"],
                        vald_diagramtyp: ["Linjediagram"],
                        valda_forvaltningar: {
                            "Alla förvaltningar": true,
                            "Barn- och Utbildningsförvaltningen": false,
                            "Kommunledningsförvaltningen": false,
                            "Kompetens- och Arbetslivsförvaltningen": false,
                            "Kultur- och Fritidsförvaltningen": false,
                            "Samhällsbyggnadsförvaltningen": false,
                            "Samhällsskyddsförvaltningen": true,
                            "Socialförvaltningen": false,
                        },
                        from_date: new Date().setMonth(new Date().getMonth() - 3), // "2022-01-01",
                        to_date: new Date().toLocaleDateString("sv"),
                        interval: 1,
                        show_percent: "true",
                        show_ongoing: "true",
                    },
                ],
                options_diagramtyper: [
                    "Linjediagram",
                    "Stapeldiagram"
                ],
                valda_forvaltningar: {
                    "Alla förvaltningar": true,
                    "Barn- och Utbildningsförvaltningen": true,
                    "Kommunledningsförvaltningen": true,
                    "Kompetens- och Arbetslivsförvaltningen": true,
                    "Kultur- och Fritidsförvaltningen": true,
                    "Samhällsbyggnadsförvaltningen": true,
                    "Samhällsskyddsförvaltningen": true,
                    "Socialförvaltningen": true,
                },
                valda_inrors_string: "",
                valda_inrors: [
                    "Sjuk",
                    "Vård av barn"
                ],
                options_inrors: [
                    "Föräldraledig",
                    "Semester",
                    "Sjuk",
                    "Studier",
                    "Tjänstledig",
                    "Uppdrag",
                    "Vård av barn"
                ],
                forvaltn_object: [
                    { "short": "BU", "long": "Barn- och Utbildningsförvaltningen", "color": "#0b84a5" },
                    { "short": "KLF", "long": "Kommunledningsförvaltningen", "color": "#36720c" },
                    { "short": "KAF", "long": "Kompetens- och Arbetslivsförvaltningen", "color": "#6f00ce" },
                    { "short": "KOF", "long": "Kultur- och Fritidsförvaltningen", "color": "#9dd866" },
                    { "short": "SBF", "long": "Samhällsbyggnadsförvaltningen", "color": "#ffaa00" },
                    { "short": "SSF", "long": "Samhällsskyddsförvaltningen", "color": "#ff0000" },
                    { "short": "SOC", "long": "Socialförvaltningen", "color": "#00cbc4" },
                    { "short": "ALLA", "long": "Alla förvaltningar", "color": "#333333" }
                ],
                inrors_object: [
                    { "short": "FLE", "long": "Föräldraledig" },
                    { "short": "SEM", "long": "Semester" },
                    { "short": "SJK", "long": "Sjuk" },
                    { "short": "STU", "long": "Studier" },
                    { "short": "TLE", "long": "Tjänstledig" },
                    { "short": "UPP", "long": "Uppdrag" },
                    { "short": "VAB", "long": "Vård av barn" }
                ],
                response_forvaltningsnamn: [],
                response_franvaro: [],
                response_all_pagaende_franvaro: [],
                response_anstallda: [],
                isLoading: false,
            };
        },
        created: function () {
            // Den här funktionen körs före något visats, så här är det bra att ladda data man behöver.
        },
        computed: {
        },
        watch: {
            // Om du behöver hålla koll på när variabler byter värde för att t.ex. köra olika funktioner beroende på värdet variablerna fått, så gör du det här.
            valt_snabbval(new_val) {
                if (new_val) {
                    //alert(new_val.valda_inrors + ", " + new_val.vald_diagramtyp);

                    this.valda_inrors = new_val.valda_inrors;
                    this.vald_diagramtyp = new_val.vald_diagramtyp;
                    this.valda_forvaltningar = new_val.valda_forvaltningar;
                    this.from_date = new_val.from_date;
                    this.to_date = new_val.to_date;
                    this.interval = new_val.interval;
                    this.show_percent = new_val.show_percent;
                    this.show_ongoing = new_val.show_ongoing;

                    this.Get_all_pagaende_franvaro();


                }
            },
            from_date(new_val) {
                this.from_date = new Date(new_val).toLocaleDateString("sv");
            },
            to_date(new_val) {
                this.to_date = new Date(new_val).toLocaleDateString("sv");
            }

        },
        mounted: function () {
            // Den här funktionen körs i samband med att sidan renderas första gången.
            // Alltså exempelvis inte vid en uppdatering pga av att en variabel triggar en förändring av sidans innehåll.
            this.to_date = new Date().toLocaleDateString("sv");
            this.from_date = this.get_date_n_months_from_input_date(this.to_date, -3);
            this.Get_all_pagaende_franvaro();

            document.getElementById("fromdatum").setAttribute("min", "2019-05-01");
            document.getElementById("fromdatum").setAttribute("max", new Date().toLocaleDateString('sv')); // i förrgår
            document.getElementById("tomdatum").setAttribute("min", "2019-05-02");
            document.getElementById("tomdatum").setAttribute("max", new Date().toLocaleDateString('sv')); // igår

        },
        components: {
            // Alert-komponenten ligger med, men används än så länge inte alls i det här projektet.
            Alert
        },
        methods: {

            // Idéer:
            // [ ] Vid procent och interval > 1: Ta ett genomsnitt av alla värden i intervallet istället för dagens värde.
            // [ ] Vid antal och interval > 1: Ta summan av alla värden i intervallet istället för dagens värde.
            // [ ] Spara-funktion för att spara inställningar med egna namn (lokalt) och/eller i databas på Loopia?
            // [X] Begränsa datumen. 2019-05-01 ska vara det lägsta, igår ska vara det högsta.




            check_dates: function () {

                var today = new Date().toISOString().slice(0, 10)
                var _yesterday = this.get_date_n_days_from_input_date(today, -1);
                var _the_day_before_yesterday = this.get_date_n_days_from_input_date(today, -2);
                if (this.from_date >= this.to_date) {
                    this.to_date = this.get_date_n_days_from_input_date(this.from_date, 1);
                }

                if (this.from_date > _the_day_before_yesterday) {
                    this.from_date = _the_day_before_yesterday;
                }

                if (this.to_date > _yesterday) {
                    this.to_date = _yesterday;
                }

            },


            // Hämtar all data från databasen (online) eller från json-fil (lokalt)
            Get_all_pagaende_franvaro: async function () {

                this.display_loader();
                var that = this;

                if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {

                    that.local_console_log("###  Get_all_pagaende_franvaro() LOCAL");


                    $.get('../local_data/franvaro_testdata.json', function (readData) {
                        that.response_all_pagaende_franvaro = readData;
                        that.display_chart();
                        that.isLoading = false;
                    })

                } else {

                    that.local_console_log("###  Get_all_pagaende_franvaro() WEB");

                    var MySQL_string = "SELECT * FROM all_pagaende_franvaro WHERE DATUM >= '" + this.from_date + "' AND DATUM <= '" + that.to_date + "'";

                    // Använd SendMySQLquery för att skicka MySQL-frågan via php till databasen
                    var response = await global_resources.methods.SendMySQLquery(MySQL_string, (result) => that.page = result);
                    response = "[" + response.slice(0, -1) + "]";
                    console.log(response);
                    var obj = JSON.parse(response);
                    that.response_all_pagaende_franvaro = obj;
                    that.display_chart();
                    that.isLoading = false;
                }

            },


            display_loader: function (_show = true) {

                var _display = "1";
                if (!_show) {
                    _display = "0";
                }
                $("#laddtext").css("opacity", _display);

            },


            // Plocka data enligt inställningarna och visa diagram
            display_chart: function () {

                this.display_loader();

                // Skapar en variabel och lägger in html-elementet var id är "chart_1" - det är det elementet som kommer att utgöra canvas för diagrammet.
                var chartDom = document.getElementById("chart_1");



                var yAxis_name = "Antal";
                var yAxis_enhet = "st";
                if (this.show_percent == "true") {
                    yAxis_name = "%";
                    yAxis_enhet = "%";
                }

                var extension_if_paborjas = "";
                $("#explaining_text").text("Visar pågående, inkl. tidigare påbörjad frånvaro.");
                if (this.show_ongoing == "false") {
                    extension_if_paborjas = "_NY";
                    $("#explaining_text").text("Visar endast frånvaro som påbörjats vid varje datapunkt.");
                }


                // Skapar en variabel med namnet "chart_type" och lägger in någon av strängarna "line" och "bar", beroende på vad det står i this.vald_diagramtyp (ett val användaren kan göra på sidan).
                var chart_type;
                if (this.vald_diagramtyp == "Linjediagram") {
                    chart_type = "line"
                } if (this.vald_diagramtyp == "Stapeldiagram") {
                    chart_type = "bar"
                }


   

                // Skapar några array-variabler som vi ska fylla med nyttiga saker strax
                var xAxis_data = [];
                var legend_data = [];
                var series_data = [];
                var _key_franv = "";
                var _key_anst = "";

                var _antal;
                var _percentage;

                var datum_array = this.get_dates_in_range(this.from_date, this.to_date);
                for (var i = 0; i < datum_array.length; i++) {

                    this.local_console_log("display_chart 8b: datum_array[" + i + "] = " + datum_array[i]);

                    var day_data = this.get_day_data(datum_array[i]);

                    this.local_console_log("display_chart 8b2: typeof day_data = " + typeof day_data);

                    if (typeof day_data != "undefined") {

                        this.local_console_log("display_chart 8c: day_data = " + day_data);
                        this.local_console_log("display_chart 8d: JSON.Stringify(day_data) = " + JSON.stringify(day_data));

                        this.local_console_log("display_chart 9");
                        // Hämta datumet och lägg in i variabeln xAxis_data, så vi får rätt labels under x-axeln sedan.
                        xAxis_data.push(day_data["DATUM"]);

                        for (var k = 0; k < this.forvaltn_object.length; k++) {

                            this.local_console_log("display_chart 10: k = " + k);

                            _key_anst = "ANST_" + this.forvaltn_object[k].short;
                            var antal_anstallda = parseInt(day_data[_key_anst]);
                            var use_this_value = 0;

                            for (var g = 0; g < this.valda_inrors.length; g++) {

                                this.local_console_log("display_chart 11a: g = " + g);

                                _key_franv = "FR_" + this.get_short_inrors(this.valda_inrors[g]) + "_" + this.forvaltn_object[k].short + extension_if_paborjas;
                                this.local_console_log("display_chart 11b: _key_franv = " + _key_franv);

                                use_this_value += parseInt(day_data[_key_franv]);

                            }

                            this.local_console_log("display_chart 12b: use_this_value = " + use_this_value);

                            _antal = use_this_value;
                            _percentage = (use_this_value / antal_anstallda) * 100;
                            _percentage = this.roundMe(2, _percentage);
                           

                            if (this.show_percent == "true") {
                                use_this_value = (use_this_value / antal_anstallda) * 100;
                                use_this_value = this.roundMe(2, use_this_value);                               
                            }

                            if (legend_data.indexOf(this.forvaltn_object[k].long) == -1) {

                                legend_data.push(this.forvaltn_object[k].long);

                                series_data.push({
                                    name: "" + this.forvaltn_object[k].long,
                                    type: chart_type,
                                    smooth: true,
                                    lineStyle: { color: this.forvaltn_object[k].color, width: 2 },
                                    symbolSize: 4,                       
                                    tooltip: {
                                        trigger: "item",                                        
                                        valueFormatter: value => value + " " + yAxis_enhet,
                                                                                                                      
                                        formatter: function (params) {
                                            return `<strong>${params.seriesName}</strong><br />${params.name}<br />Antal anställda: ${params.data.anst} st<br />Frånvarande: ${params.data.antal} st (${params.data.percentage}%)<br />`;;
                                        }
                                    },
                                    itemStyle: {
                                        color: this.forvaltn_object[k].color,
                                    },
                                    data: [{ value: use_this_value, antal: _antal, percentage: _percentage, anst: antal_anstallda } ],                                  
                                });
                            } else {

                                for (var h = 0; h < series_data.length; h++) {

                                    if (series_data[h]["name"] == this.forvaltn_object[k].long) {
                                        // Lägg till procentvärdet eller antalsvärdet, vilket det nu är användaren valt på sidan.
                                        series_data[h]["data"].push({ value: use_this_value, antal: _antal, percentage: _percentage, anst: antal_anstallda });                                    
                                    }
                                }

                            }

                        }

                    }

                }


                this.local_console_log("series_data = " + JSON.stringify(series_data));


                // Skapar en variabel med namnet "option" och lägger in ett objekt med information för att echarts.js ska kunna rita diagrammet som vi vill.
                //      title = rubrik för diagrammet. Denna hamnar på ett dumt ställe och det är orsaken till att den är satt till en tom sträng, så vi slipper se störande text i diagrammet.
                //      tooltip = har ännu inte undersökt vilka roliga saker vi kan använda denna key till.
                //      legend.data = i vårt fall: förvaltningsnamnen skickas in här
                //      xAxis.data = i vårt fall: datum
                //      xAxis.name = i vårt fall: satt till tom sträng för att vi inte behöver visa något namn för x-axeln
                //      xAxis.axisLabel.formatter = det går att formattera texten, men här har vi valt att inte göra det alls
                //      xAxis.axisLabel.align = var ska labeln hamna? Vänster/centrerad/höger?
                //      yAxis.name = i vårt fall: satt till tom sträng för att vi inte behöver visa något namn för y-axeln
                //      yAxis.axisLabel.formatter = här har vi valt att lägga till enheten till den automatiska texten för labels på y-axeln. Alltså "st" eller "%" kommer att visas bredvid värdena.
                //      yAxis.axisLabel.align = var ska labeln hamna? Vänster/centrerad/höger?
                var option = {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: '' },          //shadow eller crosss             
                    },
                    legend: {
                        orient: 'horizontal',
                        data: legend_data,
                        selected: this.valda_forvaltningar
                    },
                    xAxis: {
                        data: xAxis_data,
                        name: "",
                        axisLabel: {
                            formatter: '{value}',
                            align: 'center'
                        }
                    },
                    yAxis: {
                        name: "",
                        axisLabel: {
                            formatter: "{value} " + yAxis_enhet,
                            align: "right"
                        }
                    },
                    series: series_data
                };

                // Lägg in en relevant underrubrik genom att sätta variabeln som håller texten för underrubriken. De valda frånvaroorsakerna går igenom reningsfunktionen "clean_valda_inrors".
                this.valda_inrors_string = this.clean_valda_inrors(this.valda_inrors);



                // Följande kod tar hand om tömning av befintligt diagram, om sådant finns.
                if (
                    this.echart1 != null &&
                    this.echart1 != '' &&
                    this.echart1 != undefined
                ) {
                    this.echart1.dispose();
                }

                // Initierar och lägger in canvas, som vi skapade nyss, i variabeln this.echart1 (detta gör vi för att kunna tömma canvas när vi vill skapa ett nytt diagram).
                this.echart1 = echarts.init(chartDom);



                // Slutligen är det dags att skicka in all information till vårt diagramobjekt som är this.echart1
                // "true" som skickas in som en andra parameter som är "notMerge?", gör att diagrammet inte slås ihop med det som redan eventuellt finns i objektet. Vi får då ett nytt och rent diagram varje gång. :-)
                option && this.echart1.setOption(option, true);


                var that = this;
                this.echart1.on('legendselectchanged', function (params) {
                    that.valda_forvaltningar = params.selected;
                });

                // Stäng inställningsmenyn
                this.side_menu_open_close(true);


                this.display_loader(false);

            },

            // Logga bara när vi kör lokalt
            local_console_log: function (_text) {

                //if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
                //    console.log(_text);
                //}

            },

            // Denna funktion tar inskickad sträng och byter ut alla citattecken och brackets, och returnerar en lite trevligare sträng.
            clean_valda_inrors: function (the_string) {
                the_string = JSON.stringify(the_string);
                the_string = the_string.replaceAll('"', '').replace('[', '').replace(']', '').replaceAll(',', ', ');
                return the_string;
            },

            // Den här funktionen animerar sidomenyn så den glider in/ut på sidan.
            // Anropet ligger i template/html-delen högst upp på sidan
            side_menu_open_close: function (should_close = false) {

                // Skapar en konstant som innehåller det html-element som använder klassen side_menu.
                const side_menu = document.querySelector(".side_menu");

                // Skapar en variabel och sätter den till en array som har ett objekt i sig, med key/name "left" och value "-310px".
                // Denna variabel ska sedan användas för att tala om slutpositionen för animationen
                var movement = [
                    { left: "-340px" }
                ];

                // Om sidomenyn redan står längre till vänster på skärmen än 0 (pixel noll i sidled) vill vi att slutpositionen istället ska vara "0px".
                if (side_menu.getBoundingClientRect().left < 0 && !should_close) {
                    movement = [
                        { left: "0px" }
                    ];
                }

                // Vi skapar ett objekt som ska användas för att tala om för browsern hur animationen ska göras.
                //      duration: 400 = animationen ska ta 0,4 sekunder att slutföra.
                //      iterations: 1 = animationen ska göras en enda gång.
                //      easing: "ease-in-out" = animationen ska starta lite mjukt, och avslutas lite mjukt.
                //      fill: "forwards" = låt html-elementet vi animerar stanna kvar där den hamnade när animationen är slutförd.
                const timing = {
                    duration: 400,
                    iterations: 1,
                    easing: "ease-in-out",
                    fill: "forwards"
                }

                // Genom att använda de konstanter och variabler vi skapat ovan, säger vi nu till browsern sätta igång att animera.
                side_menu.animate(movement, timing);

            },

            // Returnerar förkortningen av en frånvaroorsak
            get_short_inrors: function (inrors_string) {
                var ret_string = "";
                for (var i = 0; i < this.inrors_object.length; i++) {
                    if (this.inrors_object[i].long == inrors_string) {
                        ret_string = this.inrors_object[i].short;
                    }
                }
                return ret_string;
            },

            // Den här funktionen returnerar data för given dag.
            get_day_data: function (_DATUM) {
                var _obj = {};
                try {
                    const index = this.response_all_pagaende_franvaro.findIndex(object => { return object.DATUM == _DATUM; });
                    _obj = this.response_all_pagaende_franvaro[index];
                } catch (error) {
                    this.local_console_log(_DATUM + " finns inte i databasen!");
                }
                return _obj;
            },

            // Funktion för att avrunda numeriska värden på ett korrekt sätt
            roundMe: function (nFigs, num) {
                return +(Math.round(num + "e+" + nFigs) + "e-" + nFigs);
            },

            // Funktion som returnerar en array med alla datum som finns mellan inskickat startdatum och slutdatum.
            // Startdatum och slutdatum inkluderas i svaret som returneras.
            get_dates_in_range: function (startDate, endDate) {

                this.local_console_log("get_dates_in_range: startDate=" + startDate + ", endDate=" + endDate);

                const date = new Date(startDate);
                endDate = new Date(endDate);
                var dates = [];
                while (date <= endDate) {
                    dates.push(new Date(date).toLocaleDateString("sv"));
                    date.setDate(date.getDate() + parseInt(this.interval));
                }
                return dates;
            },

            // Returnera datum n månader från input_date.
            get_date_n_months_from_input_date: function (input_date, n) {
                var ret_date = new Date(input_date);
                ret_date.setMonth(ret_date.getMonth() + n);
                return ret_date.toLocaleDateString("sv");
            },

            // Returnera datum n dagar från input_date.
            get_date_n_days_from_input_date: function (input_date, n) {
                var ret_date = new Date(input_date);
                ret_date.setDate(ret_date.getDate() + n);
                return ret_date.toLocaleDateString("sv");
            },

        },
    };
</script>




<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

    #procent + .btn-label:before, #pagaende + .btn-label:before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 100%;
        z-index: -1;
        background-color: rgb(127, 177, 127);
        transition: all 0.3s ease;
        border-radius: 15px;
    }

    #procent:checked + .btn-label:before, #pagaende:checked + .btn-label:before {
        left: 0;
    }

    #procent:checked + .btn-label,
    #antal:checked + .btn-label,
    #pagaende:checked + .btn-label,
    #startar:checked + .btn-label {
        color: #FFF;
    }

    .input_date {
        width: 100% !important;
    }

    .my_spacer {
        width: 20px;
    }

    #button_fetch {
        margin-top: 90px;
    }

    .explaining_text {
        font-size: 18px;
        text-align: center;
    }

    #laddtext {
        margin-left: calc(50% - 100px);
        top: 500px;
        width: 200px;
        height: 50px;
        background-color: rgba(255,255,255,0.8);
        color: rgb(255,136,51);
        font-size: 20px;
        text-align: center;
        padding-top: 8px;
        position: absolute;
        z-index: 10000;
        border-radius: 100px;
        border: 2px solid rgb(255,136,51);
        pointer-events: none;
    }
</style>


// WEBPACK FOOTER //
// src/Franvaro.vue